var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.688 23.719v6.937c0 5.85-5.457 10.594-12.188 10.594-6.731 0-12.188-4.744-12.188-10.594V23.72c0 5.85 5.457 10.031 12.188 10.031 6.731 0 12.188-4.181 12.188-10.031z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.688 14.344a8.82 8.82 0 0 1-1.294 4.631c-2.006 3.3-6.131 5.4-10.894 5.4-4.762 0-8.887-2.1-10.894-5.4a8.82 8.82 0 0 1-1.293-4.631c0-2.925 1.368-5.569 3.562-7.481C16.087 4.93 19.125 3.75 22.5 3.75s6.413 1.181 8.625 3.094c2.194 1.931 3.563 4.575 3.563 7.5z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.688 14.344v9.375c0 5.85-5.457 10.031-12.188 10.031-6.731 0-12.188-4.181-12.188-10.031v-9.375c0-5.85 5.457-10.594 12.188-10.594 3.375 0 6.413 1.181 8.625 3.094 2.194 1.931 3.563 4.575 3.563 7.5z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsIcon);
export default __webpack_public_path__ + "static/media/coinsIcon.3bd79af0b1ef38d9d0b706e0336e86d2.svg";
export { ForwardRef as ReactComponent };